module.exports = __webpack_public_path__ + "img/sample-ktp3.fa0136a9.png";